import { GetExcelRequest, GetRequest, PutRequest } from "../service"

const ControllerName = "ProviderProfile" // This controller for provider registration request

export const GetProviderProfile = () => {
    return GetRequest(ControllerName)
}
export const GetProviderProfileInfo = () => {
    return GetRequest(`${ControllerName}/getInfo`)
}

export const UpdateProviderProfile = (dataObject) => {
    return PutRequest(`${ControllerName}`, dataObject?.formData)
}

export const GetProviderProfileExternalData = () => {
    return GetExcelRequest(`${ControllerName}/download-services/excel`)
}



export const UploadProviderPricing = (dataObject) => {

    return PutRequest(`${ControllerName}/upload-provider-pricing` , dataObject?.formData)
}